import { TranslatableQuery } from './translatable-query';

import { Page } from './../data';

export class PageQuery extends TranslatableQuery<Page> {
  constructor(pageId?: string) {
    super(Page);

    if (pageId) {
      this.equalTo(Page.OBJECT_ID_KEY, pageId);
    }
  }

  public search(searchText: string, lang: string) {
    this.orQuery([
      new PageQuery().searchTranslationKey(Page.TITLE_KEY, searchText, lang),
      new PageQuery().searchTranslationKey(Page.NAME_KEY, searchText, lang),
      new PageQuery().searchTranslationKey(Page.CONTENT_KEY, searchText, lang),
    ]);
    return this;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/queries/page-query.ts